import React from 'react'

function Notifications() {
  return (
    <div className=" ">
      Notifications
    </div>
  );
}

export default Notifications